import { useEffect, useRef } from "react";
import Icon from "../../Elements/Icon/Icon.tsx";
import Tooltip from "../../Elements/Tooltip/Tooltip.js";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import FolderActionsDropDown from "./FolderActionsDropDown.tsx";
import useOnClickOutside from "../../../hooks/useOnClickOutside.js";
import Image from "../../Elements/Image/Image.tsx";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import { useState } from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useMailView } from "contexts/mailViewContext/mailViewContext.js";
import { headerIcons } from "components/Pages/Inbox/Mails/FilesPreviewComponent.js";
import bytesToDisplayHelper from "utils/bytesToDisplayHelper.js";
import { withSize } from "react-sizeme";

const FolderTabImages = ({ fileData, index }) => {
  const filePreview = fileData.source;
  const fileIcon = headerIcons[fileData.type];

  return filePreview ? (
    <Image src={filePreview} className={`folder-preview-image-${index + 1}`} />
  ) : (
    <div className={`file-icon-wrapper-${index + 1}`}>
      <Icon name={fileIcon} />
    </div>
  );
};

const FolderTab = ({ showAll, i, id, limit }) => {
  const [showActions, setShowActions] = useState(false);
  const { getTextByKey } = useContent();
  const { getFoldersData, setCurrentFolder } = useMail();
  const { mobileCondition } = useMediaQueries();
  const { getMobileGridView } = useMailView();

  const ref = useRef();
  useOnClickOutside(ref, () => setShowActions(false));
  const { folderName, nestedFilesCount, previewItems, nestedFilesSize } =
    getFoldersData()[id];

  const { size, type } = bytesToDisplayHelper(nestedFilesSize);

  const [style, setStyle] = useState({});

  useEffect(() => {
    let timeoutId;

    if (showActions) {
      setStyle({
        zIndex: 10,
      });
    } else {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setStyle({});
      }, 300);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [showActions]);

  const previewList = previewItems || [
    {
      type: "Folder",
    },
    {
      type: "Folder",
    },
  ];

  return (
    <div
      className={`gallery-available-folder${
        showAll || i < limit ? "" : " none-display"
      }${!getMobileGridView() && mobileCondition ? " feed-view" : ""}`}
      key={id}
      onClick={() => {
        setCurrentFolder(id);
      }}
      style={style}
    >
      {!mobileCondition && (
        <div className="folder-files-preview">
          {previewList.map((fileData, i) => (
            <FolderTabImages fileData={fileData} index={i} key={i} />
          ))}
          <div className="folder-files-decorator" />
        </div>
      )}
      <div className="folder-title">
        <div className="gallery-available-folder-text">
          <Tooltip tooltipText={folderName}>{folderName}</Tooltip>
          <div className="folder-info">
            {size} {type} ({nestedFilesCount} {getTextByKey("files")})
          </div>
        </div>
        <div
          className="folder-additional-functionality"
          onClick={(e) => {
            e.stopPropagation();
            setShowActions((prev) => !prev);
          }}
          ref={ref}
        >
          <Icon name="vertical-three-dots" gray />
          <FolderActionsDropDown
            folderId={id}
            showActions={showActions}
            topPos={55}
          />
        </div>
      </div>
    </div>
  );
};

const AvailableFolders = ({ size }) => {
  const { width } = size;
  const { getAvailableFoldersList, getFolderStructured } = useMail();
  const { getGridView } = useMailView();

  const { getTextByKey } = useContent();
  const { mobileCondition } = useMediaQueries();

  const [showAll, setShowAll] = useState(false);

  if (!getGridView()) {
    return null;
  }
  // width 220px in desktop is hardcoded from css, so should ba changed in case UI changes
  const limit = mobileCondition ? 4 : Math.floor((width - 30) / 250);

  if (!getFolderStructured()) return null;

  return (
    <>
      <div className="gallery-available-folders">
        {getAvailableFoldersList().map((id, i) => {
          return <FolderTab {...{ id, i, showAll, limit }} key={id} />;
        })}
      </div>
      {getAvailableFoldersList().length >= limit + 1 ? (
        <div
          className={`show-all-folders ${
            !showAll ? "show-position" : "hide-position"
          }`}
          onClick={() => setShowAll(!showAll)}
        >
          {!showAll
            ? getTextByKey("show-folders-action")
            : getTextByKey("hide-folders-action")}
          <Icon name="arrow-down-solid" small dark />
        </div>
      ) : null}
    </>
  );
};
export default withSize({ monitorWidth: true })(AvailableFolders);
